import { observable, computed, action, useStrict } from "mobx";
import BaseStore from "./BaseStore";
import api from "../api/api";
import utils from "../utils/utils";
import * as allUrls from "../router/allUrls";
import foStorage from "../utils/foStorage";
import storeMine from "./storeMine";
import { URL_INDEX } from "../consts/consts";
import { CODE_WEIXIN_KEY_NOT_EXISTS } from "../consts/error_codes";
import storeGlobal from "./storeGlobal";

useStrict(true);

class StoreLogin extends BaseStore {
  constructor() {
    super();
    this.mobile = foStorage.getItem(foStorage.KEYS.mobile) || "";
  }
  @observable
  showPassword = false;
  @observable
  isLoading = false;
  @observable
  mobile = "";
  @observable
  code = "";
  @observable
  password = "";
  @observable
  countryCode = "";

  @computed
  get countryCodeText() {
    const c = storeGlobal.countryCodes.find(
      item => item.prefix + "" === this.countryCode + ""
    );
    if (c) {
      return c.code;
    }
    return "+86";
  }

  @computed
  get mobileTrimed() {
    return utils.removeSpaces(this.countryCode + this.mobile);
  }

  @computed
  get returnUrl() {
    const { return_url } = utils.getUrlQuery();
    return return_url || URL_INDEX;
  }

  @action.bound
  checkLoginStatusAndRedirect() {
    if (utils.isLogin()) {
      const profile = foStorage.getItem(foStorage.KEYS.profile);
      if (profile) {
        this.onLoginSuccessRedirect(profile);
        return true;
      }
    }
    return false;
  }

  @action.bound
  async doLoginByWeixin(shouldBindPhone = true) {
    const key = this.getWeixinAuthKey();
    if (!key) {
      alert(CODE_WEIXIN_KEY_NOT_EXISTS.toString());
      // window.location.reload();
      return;
    }
    utils.toast.loading("微信授权中");
    const {
      data: { data }
    } = await api.checkWxLoginResult({
      // "open_id":"oIovdv9vNcj0-uEOTFjlmJY8o9_E",
      code: key,
      source: utils.getOrganizationWechatAppId() || "0"
    });
    utils.toast.hide();

    console.log(data);

    if (data) {
      // 如果有token, 那么说明已经绑定手机, 直接登录成功跳转
      if (data.token) {
        this.onLoginSuccessRedirect(data);
        return;
      }

      if (!shouldBindPhone) {
        this.redirectToReturnUrl();
        return;
      }

      // 需要绑定手机, 前往绑定手机页面
      if (data.mobile_bind === 0) {
        allUrls.urlPageBindPhone.pushMe();
        return;
      }
    }
  }

  @action.bound
  async doLoginBySms() {
    this.update({
      isLoading: true
    });
    const { _data } = await api.loginBySms({
      mobile: this.mobileTrimed,
      code: this.code,
      key: this.getWeixinAuthKey()
    });

    this.update({
      isLoading: false
    });
    if (_data && _data.token) {
      this.onLoginSuccessRedirect(_data);
    }
  }

  @action.bound
  async doBindPhone(callback) {
    this.update({
      isLoading: true
    });
    const {
      data: { data }
    } = await api.bindPhone({
      mobile: this.mobileTrimed,
      code: this.code,
      key: this.getWeixinAuthKey()
    });
    this.update({
      isLoading: false
    });
    if (data && data.token) {
      this.onLoginSuccessRedirect(data, callback);
    }
  }

  @action.bound
  async doLoginByPassword() {
    this.update({
      isLoading: true
    });
    const { _data } = await api.loginByPassword({
      mobile: this.mobileTrimed,
      password: this.password,
      key: this.getWeixinAuthKey()
    });
    this.update({
      isLoading: false
    });
    if (_data && _data.token) {
      this.onLoginSuccessRedirect(_data);
    }
  }

  @action.bound
  async doPerfectInfo(params) {
    this.update({
      isLoading: true
    });
    await api.bindPerfectInfo(params);
    this.update({
      isLoading: false
    });
    this.redirectToReturnUrl();
  }

  @action.bound
  reset() {
    this.showPassword = false;
    this.code = "";
    this.password = "";
  }

  @action.bound
  syncTokenFromApp() {
    if (utils.isFoApp()) {
      const token = utils.cookies.get("fo_token");
      console.log(token);
      if (!token) {
        // document.cookie='fo_token=abc33;path=/;domain=devnewapi.foschool.cn'
        utils.toast.info(
          "请客户端在cookie中设置fo_token, 如果客户端未登录, 请设置fo_token=none"
        );
        return;
      }
      if (token === "none") {
        utils.clearUserLoginData();
      } else {
        foStorage.setItem(foStorage.KEYS.token, token);
        const newToken = foStorage.getItem(foStorage.KEYS.token);
        if (newToken !== token) {
          alert("同步客户端token失败: " + token);
        }
      }

      return;
    }

    const { t, from } = utils.getUrlQuery();

    if (from === "miniProgram") {
      if (!t) {
        utils.clearUserLoginData();
      } else {
        foStorage.setItem(foStorage.KEYS.token, t);
        console.log("token: ", foStorage.getItem(foStorage.KEYS.token));
      }

      let url = window.location.href;
      url = utils.removeUrlQuery(url, ["t", "from"]);

      utils.replaceUrl(url);
    }
  }

  @action.bound
  onLoginSuccessRedirect(profile, callback) {
    this.reset();

    if (profile) {
      foStorage.setItem(foStorage.KEYS.token, profile.token);
      foStorage.setItem(foStorage.KEYS.profile, profile);
    }

    if (this.mobile) {
      foStorage.setItem(foStorage.KEYS.mobile, this.mobile);
    }
    storeMine.setProfileFromStorage();

    if (typeof callback === "function") {
      callback();
      return;
    }

    this.redirectToReturnUrl();

    // 调用登录成功回调 (因为使用强刷方式return_url, 所以这里基本没啥用处了)
    utils.callLoginCallback();
  }

  @action.bound
  redirectToReturnUrl(return_url) {
    // 这里必须设置一个延迟, 否则登录页进行跳转时, 微信分享配置不会生效
    setTimeout(() => {
      // 跳转到 return_url, 这里用整页刷新方式, 因为return_url可能为微信支付页, 必须强刷才可以支付
      window.location.replace(return_url || this.returnUrl);
      // utils.replaceUrl(this.returnUrl);
    }, 0);
  }

  @action.bound
  saveWeixinAuthKey(key) {
    // wxAuthKey默认失效时间为20分钟
    const expiration = new Date().getTime() + 20 * 60 * 1000;
    foStorage.setItem(foStorage.KEYS.wxAuthKey, key, expiration);
  }

  getWeixinAuthKey() {
    return foStorage.getItem(foStorage.KEYS.wxAuthKey);
  }

  // 绑卡和密码登录页面必须有key, 否则回退到登录页重新微信授权
  ensureWxKeyExists(detectOnlyInWeixin = true) {
    const key = this.getWeixinAuthKey();
    if (
      !key &&
      ((detectOnlyInWeixin && utils.isWeiXin()) || !detectOnlyInWeixin)
    ) {
      allUrls.urlPageLogin.replaceMe();
    }
  }
}

export default new StoreLogin();



// WEBPACK FOOTER //
// ./src/store/storeLogin.js